module.exports = __webpack_public_path__ + "img/ic_institutaion.71f80faa.svg";